// const validator = require('validator');

class Format {

    fmtBizNumber(value) {
        if(value) {
            return value.replace(/[^0-9]/g, "").replace(/([0-9]{3})([0-9]{2})([0-9]+)?/, "$1-$2-$3").replace("--", "-");
        }
        return value;
    }

    fmtPhoneNumber(value) {
        if(value) {
            return value.replace(/[^0-9]/g, "").replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/,"$1-$2-$3").replace("--", "-");
        }
        return value;
    }

    fmtNumber(value) {
        if(value) {
            return value.replace(/[^0-9]/g, '');
        }
        return value;
    }

    fmtPrimeNumber(value) {
        if(value) {
            return value.replace(/[^0-9.-]/g, "");
        }
        return value;
    }

    fmtFloat(value) {
        if(value) {
            return value.replace(/[^0-9.-]/g, "");
        }
        return value;
    }

    fmtResetObject(obj) {
        for (const key in obj) {
            obj[key] = null;
        }
        return obj
    }
   

}

export default new Format()
